/**
 * What the plan and billing UI offers, by the client's plan state.
 *
 * One rule for every surface that shows plans (the dashboard banner, /plans
 * and Account settings), kept here so they cannot disagree again: until
 * 2026-11-04 the banner marked a trial's own tier "Current plan" while /plans
 * did not, so a Starter trial could not choose Starter from the dashboard.
 *
 * Plain JavaScript with no browser or Vite globals, so
 * backend/tests/test_plan_state.py runs this file under node.
 */

// A subscription is running: its tier is the current plan.
export const PAID_STATUSES = ['active', 'past_due']

/**
 * The tier to mark "Current plan" (and so not buyable), or null. Only a paid
 * subscription has one. A trial, or a plan that has ended, can choose its own
 * tier: buying it is how the digests keep coming.
 */
export function currentPaidTier(prefs) {
  return PAID_STATUSES.includes(prefs?.plan_status) ? prefs.plan_tier : null
}

/**
 * Which billing buttons Account settings shows. The Stripe portal exists only
 * once the client has a Stripe customer, created at their first checkout;
 * before that it answers 400 ("No billing account yet"), so a trial is
 * offered the plans instead. An ended plan gets both: the plans to come back,
 * and the portal for its invoices. So does anything else without a Stripe
 * customer, such as an account set active by hand (staging's synthetic
 * accounts are exactly that), which would otherwise get no button at all.
 */
export function billingActions(prefs) {
  const manageBilling = Boolean(prefs?.has_billing_account)
  return {
    choosePlan: !PAID_STATUSES.includes(prefs?.plan_status) || !manageBilling,
    manageBilling,
  }
}
